import * as React from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  FormHelperText,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchAdminDetail, fetchallpermisions } from "../../DAL/fetch";
import AlertDialog from "../../Components/Models/AlertDialog";
import { deleteAdmin } from "../../DAL/delete";
import { updateAdminData } from "../../DAL/update";
import LinearIndeterminate from "../../Components/LinearIndeterminate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";

export default function AdminDetail({ open, setOpen }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [allpermissions, setAllPermissions] = useState([]);
  const [type, setType] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const permissionsResponse = await fetchallpermisions();
        const response = await fetchAdminDetail(id);

        // Log fetched permissions data

        if (response && response.data) {
          setData(response.data.data || response.data);

          setSelectedPermissions(response.data.permissions || []);
        }

        if (permissionsResponse && permissionsResponse.data) {
          setAllPermissions(permissionsResponse.data || []);
        }
      } catch (error) {
        console.error(`Failed to fetch admin details or permissions:`, error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleToggle = (item) => {
    setSelectedPermissions(
      (prevSelected) =>
        prevSelected.some((selectedItem) => selectedItem.id === item.id)
          ? prevSelected.filter((selectedItem) => selectedItem.id !== item.id) // Unselect
          : [...prevSelected, item] // Select
    );
  };

  const handleDeleteClick = () => {
    setOpenDialog(true);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteAdmin(id);
      setOpenDialog(false);
      navigate(`/admins`);
    } catch (error) {
      console.error("Failed to delete items:", error);
    } finally {
      setLoading(false);
      setOpenDialog(false);
    }
  };
  const updateAdminDetails = async () => {
    setType(true);
    setLoading(true);
    const selectedIDS = selectedPermissions.map((item) => item.id);
    try {
      const response = await updateAdminData(id, {
        permissionIds: selectedIDS,
      });
      if (response?.status == 200) {
        enqueueSnackbar("Admin updated successfully", { variant: "success" });
        navigate("/admins");
      } else {
        if (typeof response?.message == "string") {
          enqueueSnackbar(
            response?.message ||
              response?.error ||
              response?.data?.message ||
              response?.data?.error,
            { variant: "error" }
          );
        } else {
          enqueueSnackbar(
            response?.message ||
              response?.error ||
              response?.data?.message ||
              response?.data?.error,
            { variant: "error" }
          );
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to update admin details:", error);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ padding: "3%" }}>
      <AlertDialog
        open={openDialog}
        onDelete={handleDelete}
        onCancel={() => setOpenDialog(false)}
      />
      {loading ? (
        <LinearIndeterminate />
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 1, alignItems: "center" }}>
              <ArrowBackIcon
                sx={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
              <Typography id="modal-title" variant="h5" component="h2">
                Edit Admin Detail
              </Typography>
            </div>

            {/* <Button
              onClick={handleDeleteClick}
              color="error"
              autoFocus
              variant="contained"
            >
              Delete Admin
            </Button> */}
          </Box>
          <Box
            component="form"
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth
                label="Name *"
                variant="outlined"
                value={data.name || ""}
                disabled
              />
              <TextField
                fullWidth
                label="Email *"
                variant="outlined"
                value={data.email || ""}
                disabled
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth
                label="Rid"
                variant="outlined"
                value={data.code || ""}
                disabled
              />
              <TextField
                fullWidth
                label="Role"
                variant="outlined"
                value={data.role || ""}
                disabled
              />
            </Box>
            <Typography variant="h6">Permissions *</Typography>
            {type == true && (
              <FormHelperText sx={{ color: "red" }}>
                {selectedPermissions?.length == 0 &&
                  "Please select atleast one permission"}
              </FormHelperText>
            )}
            <Box sx={{ mt: 2 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  maxHeight: "50vh",
                  overflowY: "scroll",
                }}
              >
                {allpermissions.map((allpermission) => (
                  <Grid item xs={12} sm={6} md={4} key={allpermission.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPermissions.some(
                            (selectedItem) =>
                              selectedItem.id === allpermission.id
                          )}
                          onChange={() => handleToggle(allpermission)}
                          sx={{
                            "&.Mui-checked": {
                              color: "#8F29D0",
                            },
                          }}
                        />
                      }
                      label={allpermission.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  type="button"
                  variant="contained"
                  sx={{ backgroundColor: "#B1B1B1", textTransform: "none" }}
                  onClick={() => {
                    navigate("/admins");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="gradientButton"
                  onClick={updateAdminDetails}
                  sx={{ textTransform: "none" }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
